import React from "react";
import { connect } from "react-redux";
import {Button, Row, Col, ModalFooter} from "reactstrap";
import { Field, reduxForm, FieldArray,formValueSelector } from "redux-form";
import "react-dropdown/style.css";
import { Card, CardHeader, CardBody } from 'reactstrap';
import renderSelectField from '../../../../../shared/components/form/Select';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import renderDatePickerField from "../../../../../shared/components/form/DatePicker";
import CalendarBlankIcon from "mdi-react/CalendarBlankIcon";

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = "Please enter the Job Description name";
  }
  return errors;
};

const renderField =
  ({
     input, placeholder, type, meta: { touched, error },
   }) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <input {...input} placeholder={placeholder} type={type} />
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

const renderTypeList = ({ fields, meta: { error, submitFailed } }) => {
  const allFields = fields.getAll();
  const fieldsName = fields.name;

  function renderFields(param, index) {
    if(param.label === "Severity") {
      const SEVERITY_OPTIONS = [
        { value: 'MAJOR', label: 'MAJOR' },
        { value: 'CRITICAL', label: 'CRITICAL' },
        { value: 'MINOR', label: 'MINOR' },
        { value: 'NORMAL', label: 'NORMAL' },
      ];

      return (
        <div className="form__form-group-field">
          <Field
            component={renderSelectField}
            name={`${fieldsName}.[${index}]value`}
            placeholder="Severity"
            type="select"
            options={SEVERITY_OPTIONS}
          />
        </div>
      );
    }

    if(param.label === "Date Detected") {
      return (
        <div className="form__form-group-field">
          <Field
            name={`${fieldsName}.[${index}]value`}
            component={renderDatePickerField}
          />
          <div className="form__form-group-icon">
            <CalendarBlankIcon />
          </div>
        </div>
      );
    }

    return (
      <div className="form__form-group-field">
        <Field
          component={renderField}
          name={`${fieldsName}.[${index}]value`}
          value={ param.value }
          type="text"
        />
      </div>
    );
  }

  if (allFields && Object.keys(allFields).length > 0) {
    return allFields.map((param, index) =>  {
      return (
        <div key={index} className="form__form-group">
          <span className="form__form-group-label input-as-label">
            <span className="form__form-group-label">
              { param.label }
            </span>
          </span>

          { renderFields(param, index) }
        </div>
      )
    });
  }

  return <React.Fragment />
};

let FeedbackForm = props => {
  const {
    t,
    handleSubmit,
    submitting,
    initialValues,
    feedback_type,
  } = props;
  const hasFeedback = initialValues && Object.keys(initialValues).length;

  const FEEDBACK_TYPE_OPTIONS = [
    { value: 'MAINTENANCE', label: 'MAINTENANCE' },
    { value: 'FAULT_REPORT', label: 'FAULT REPORT' },
    { value: 'FAILURE_REPORT', label: 'FAILURE REPORT' },
  ];

  return (
    <Card>
      <form onSubmit={handleSubmit}>
        <Row>
          <Col xs="12" className="form form--horizontal">

            <div className="form__form-group">
              <span className="form__form-group-label">
                  {t('asset_management.feedback_label.feedback_type')}
              </span>
              <div className="form__form-group-field">
                <Field
                  component={renderSelectField}
                  name="feedback_type"
                  placeholder="Feedback Type"
                  type="select"
                  options={FEEDBACK_TYPE_OPTIONS}
                />
              </div>
            </div>

            {
              feedback_type.value === 'MAINTENANCE'
                ? <FieldArray name="maintenance_feedback" component={renderTypeList} />
                : (
                  feedback_type.value === 'FAULT_REPORT'
                    ? <FieldArray name="fault_feedback" component={renderTypeList} />
                    : <FieldArray name="failure_feedback" component={renderTypeList} />
                )
            }

            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('asset_management.feedback_label.comments')}
              </span>
              <div className="form__form-group-field">
                <Field
                  component={renderField}
                  name="comments"
                  placeholder="comments"
                  type="text"
                />
              </div>
            </div>

            <div className={"hidden-fields"}>
              <Field
                component={renderField}
                name="asset_id"
                placeholder="asset_id"
                type="hidden"
              />

              <Field
                component={renderField}
                name="asset_id"
                type="hidden"
              />
              <Field
                component={renderField}
                name="asset_id"
                type="hidden"
              />
              <Field
                component={renderField}
                name="asset_id"
                type="hidden"
              />
            </div>

            <div className="col-md-12">
              <Button
                type="submit"
                className="icon"
                color="success"
              >
                <p>Save</p>
              </Button>
            </div>

          </Col>
        </Row>
      </form>
    </Card>
  );
};

function mapStateToProps(state, ownProps) {
  const { form_data } = ownProps;
  let newFormData = form_data && Object.keys(form_data).length > 0 ? form_data : {};

  const selectedAsset = state.assetsManagement.selectedAsset;
  const selectedComponent = state.component.selectedComponent;

  const asset_id =
    selectedAsset && selectedAsset._id
      ? selectedAsset._id : null;
  const asset_type_id =
    selectedAsset && selectedAsset.asset_type_id
      ? selectedAsset.asset_type_id : null;

  const component_id =
    selectedComponent && selectedComponent._id
      ? selectedComponent._id : null;
  const component_type_id =
    selectedComponent && selectedComponent.component_type_id
      ? selectedComponent.component_type_id : null;

  newFormData.asset_id = newFormData.asset_id || asset_id;
  newFormData.asset_type_id = newFormData.asset_type_id || asset_type_id;
  newFormData.component_id = newFormData.component_id || component_id;
  newFormData.component_type_id = newFormData.component_type_id || component_type_id;

  let feedback_type = selector(state, "feedback_type");
  feedback_type = feedback_type || { value: 'FAILURE_REPORT', label: 'FAILURE REPORT' };

  if (newFormData && newFormData.formType && newFormData.formType === "clone") {
    delete newFormData._id;
  }
  return {
    initialValues: newFormData,
    feedback_type,
    asset_id,
    asset_type_id,
    component_id,
    component_type_id,
  };
}

let FeedbackData = reduxForm({
  validate: validate,
  form: "FeedbackForm",
  enableReinitialize: true
})(FeedbackForm);

const selector = formValueSelector('FeedbackForm');

export default withTranslation('common') (connect(state => mapStateToProps,{})(FeedbackData));
